import { render } from "./ContatoFormulario.vue?vue&type=template&id=25cbf2bc&scoped=true"
import script from "./ContatoFormulario.vue?vue&type=script&lang=js"
export * from "./ContatoFormulario.vue?vue&type=script&lang=js"

import "./ContatoFormulario.vue?vue&type=style&index=0&id=25cbf2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cbf2bc"]])

export default __exports__